import React, {useEffect, useRef, useState} from 'react'
import styled from '@emotion/styled'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import BtnClose from './../../components/BtnClose'
import * as API from '../../api'
import {sha256} from 'crypto-hash'
import {messages} from './../utils/ErrorsText'
import {isSuperAdmin} from '../../modules/auth/core/Auth'
import {getUserData} from '../../modules/auth/core/Auth'
import CropperComponent from '../../pages/utils/ImageCropper'
import { userInfo } from 'os'

const StyledForm = styled.div`
  .form-item {
    display: flex;
    width: 100%;
    gap: 15px;
    margin-bottom: 16px;
    align-items: center;
    
    p {
      width: 140px;
      margin: 0;
      text-align: right;
      font-weight: 600;
      color: #181c32;
      font-size: 14px;
    }
    
    input, select {
      transition: all 0.2s ease;
      border: 2px solid #e4e6ef;
      
      &:focus {
        border-color: #009ef7;
        box-shadow: 0 0 0 4px rgba(0, 158, 247, 0.1);
      }
    }
  }
  
  .seller-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #009ef7;
    color: white;
    padding: 8px 16px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 700;
    margin-left: 12px;
    box-shadow: 0 4px 12px rgba(0, 158, 247, 0.2);
  }
  
  .super-admin-field {
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    border: 2px dashed #009ef7;
    padding: 20px;
    border-radius: 12px;
    margin-bottom: 20px;
    
    .super-admin-label {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 12px;
      font-weight: 700;
      color: #009ef7;
      font-size: 13px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      
      &::before {
        content: '🔐';
        font-size: 16px;
      }
    }
  }
`

const StyledModal = styled.div`
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
  border: 2px solid #f1f3f8;

  .card-header {
    align-items: center;
    border-bottom: 3px solid #009ef7;
    padding: 28px 36px;
    background: #f8f9fa;
    border-radius: 16px 16px 0 0;
    
    h3 {
      color: #181c32;
      font-weight: 700;
      font-size: 22px;
      margin: 0;
    }
  }

  .card-body {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 36px;
  }

  .remove-user-title {
    margin: 20px !important;
  }

  .status-item, .mailling-item, .viewer-item {
    margin-right: 30px;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 18px;
    border-radius: 10px;
    transition: all 0.2s ease;
    cursor: pointer;
    border: 2px solid transparent;
    
    &:hover {
      background-color: #f8f9fa;
      border-color: #e4e6ef;
    }

    label {
      margin: 0;
      font-weight: 600;
      color: #3f4254;
      cursor: pointer;
      font-size: 14px;
    }
    
    input[type="radio"] {
      cursor: pointer;
      width: 20px;
      height: 20px;
      
      &:checked {
        accent-color: #009ef7;
      }
    }
  }

  .cropper {
    padding-top: 10px;
    max-width: 300px;
  }
  
  .symbol img {
    border-radius: 16px;
    object-fit: cover;
    border: 4px solid #f1f3f8;
  }
  
  .alert {
    border-radius: 10px;
    border: 2px solid;
    padding: 18px 24px;
    font-size: 14px;
    font-weight: 600;
  }
  
  .alert-danger {
    background: #fff5f8;
    border-color: #f1416c;
    color: #f1416c;
  }
  
  button.btn-primary {
    border-radius: 10px;
    padding: 16px 36px;
    font-weight: 700;
    font-size: 15px;
    transition: all 0.3s ease;
    background: #009ef7;
    border: none;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    
    &:hover:not(:disabled) {
      background: #0084d4;
      transform: translateY(-2px);
      box-shadow: 0 8px 24px rgba(0, 158, 247, 0.35);
    }
    
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
  
  .domain-notice {
    background: #f1faff;
    border: 2px solid #009ef7;
    border-radius: 10px;
    padding: 16px 20px;
    text-align: center;
    margin-bottom: 24px;
    
    label {
      margin: 0;
      color: #009ef7;
      font-size: 13px;
      font-weight: 600;
      
      b {
        font-weight: 800;
      }
    }
  }
`

const UserModal = (props:any) => {
  const [loading, setLoading] = useState(false)
  const inputRef = useRef<any>(null)
  const [name, setName] = useState(props.userData?.name || '')
  const [email, setEmail] = useState(props.userData?.email || '')
  const [isAdmin, setIsAdmin] = useState(props.userData ? props.userData.is_admin : 0)
  const [isActived, setIsActived] = useState(props.userData ? props.userData.is_actived : 1)
  const [isSeller, setIsSeller] = useState(props.userData ? props.userData.is_seller : 1)
  const [isMailling, setIsMailling] = useState(
    props.userData ? props.userData.is_mailling : 1
  )
  const [isViewer, setIsViewer] = useState(props.userData ? props.userData.is_viewer : 0)
  const [idSeller, setIdSeller] = useState(props.userData?.id_seller || '')
  const [idSellerSuperAdmin, setIdSellerSuperAdmin] = useState(props.userData?.id_seller || '')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [status, setStatus] = useState('')
  const [domain, setDomain] = useState('')

  const [imageFile, setImageFile] = useState(null)
  const [croppedImage, setCroppedImage] = useState('')
  const [uploadResponse, setUploadResponse] = useState<any>()
  const [showCropper, setShowCropper] = useState(false)

  function onImageSelect(e:any) {
    if (e.target.files && e.target.files.length > 0) {
      setImageFile(e.target.files[0])
      setShowCropper(true)
    }
  }

  async function getData() {
    const response = await API.getCompanyDomain()
    setDomain(response.data.domain)
    console.log(response.data.domain)
  }

  useEffect(() => {
    getData()
  }, [])

  async function onSubmit() {
    const statusResponse:any = validationStatus()
    setStatus(statusResponse)
    if (statusResponse !== '') return
    setLoading(true)
    try {
      if (props.userData) {
        const response:any = await API.updateUser({
          user_guid: props.userData.guid,
          name: name,
          email: email,
          password: password.length ? await sha256(password) : '',
          id_upload: uploadResponse ? uploadResponse.id_upload : undefined,
          is_actived: isActived,
          is_mailling: isMailling,
          is_viewer: isViewer,
          is_admin: isAdmin,
          company_guid: props.userData.company_guid,
          id_seller: isSuperAdmin() ? idSellerSuperAdmin : (isSeller ? idSeller : undefined),
        })
        if (!response.success) {
          setStatus(messages[response.error])
          setLoading(false)
          return
        }
        props.onUserUpdated()
      } else {
        let companyGuid = isSuperAdmin()
          ? localStorage.getItem('current_company')
          : getUserData().company_guid

        const createUserData = {
          name: name,
          email: email,
          password: await sha256(new Date().getTime().toString()),
          id_upload: uploadResponse ? uploadResponse.id_upload : undefined,
          is_actived: isActived,
          is_mailling: isMailling,
          is_viewer: isViewer,
          is_admin: isAdmin,
          company_guid: companyGuid,
          id_seller: isSuperAdmin() ? idSellerSuperAdmin : (isSeller ? idSeller : undefined),
        }

        const response = await API.createUser(createUserData)
        if (!response.success) {
          setStatus(messages[response.error])
          setLoading(false)
          return
        }
        props.onUserCreated()
      }
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  function validateEmail() {
    if (props.userData && props.userData.email === email) return 'is-valid';
  
    if (/^[\w-.+]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      if (!domain || domain.trim() === '') return 'is-valid';
  
      const domainArray = domain.split(',').map(dom => dom.trim());
      const emailDomain = email.substring(email.lastIndexOf('@') + 1);
  
      if (domainArray.some(validDomain => 
          emailDomain === validDomain || emailDomain.endsWith(`.${validDomain}`)
      )) {
        return 'is-valid';
      }
    }
    return 'is-invalid';
  }

  function validateName() {
    if (name.length < 5) return 'is-invalid'
    if (props.userData && props.userData.name == name) return ''
    return ''
  }

  function validatePassword() {
    if (confirmPassword.length && !password.length) return 'is-invalid'
    if (!password.length) return ''
    if (password.length < 6) return 'is-invalid'
    return 'is-valid'
  }

  function validateConfirmPassword() {
    if (!password.length || !confirmPassword.length) return ''
    if (confirmPassword === password) return 'is-valid'
    return 'is-invalid'
  }

  function validationStatus() {
    if (validateEmail() != 'is-valid') return 'E-mail inválido'
    if (name.length < 5) return 'Nome de usuário deve conter no mínimo 5 caracteres'
    return ''
  }

  return (
    <StyledModal className='card mb-5 mb-xl-10'>
      <div className='card-header border-0'>
        <div className='card-title m-0'>
          <h3>
            {props.userData ? 'Editar Usuário' : 'Adicionar Usuário'}
          </h3>
        </div>

        <BtnClose onClick={() => props.onClose()} />
      </div>

      <div className='card mb-5 mb-xl-10'>
        <div className='card-body pt-9 pb-0'>
          <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
            <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative '>
              <div className='me-7 mb-4 justify-content-center'>
                {!croppedImage && (
                  <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
                    <img
                      src={
                        uploadResponse
                          ? uploadResponse.path
                          : props.userData?.src
                          ? props.userData.src
                          : toAbsoluteUrl('/media/icons/duotune/general/gen049.svg')
                      }
                      alt='Meu Perfil'
                    />
                  </div>
                )}
                {croppedImage && (
                  <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
                    <img src={croppedImage} alt='Perfil' />
                  </div>
                )}
                <input
                  type='file'
                  accept='image/*'
                  onChange={onImageSelect}
                  style={{display: 'none'}}
                  ref={inputRef}
                />
                <div className='row mt-2 p-0 align-center'>
                  <button 
                    onClick={() => inputRef.current?.click()} 
                    className='btn btn-primary'
                    style={{fontSize: '13px', padding: '12px 24px'}}
                  >
                    Alterar imagem
                  </button>
                </div>
                <div className='cropper'>
                  {showCropper && (
                    <CropperComponent
                      imageFile={imageFile}
                      setCroppedImage={setCroppedImage}
                      setShowCropper={setShowCropper}
                      setUploadResponse={setUploadResponse}
                    />
                  )}
                </div>
              </div>
            </div>

            <div className='flex-grow-1'>
              <div className='d-flex flex-wrap flex-stack'>
                <div className='d-flex flex-column flex-grow-1 pe-8'>
                  <StyledForm>
                    {domain && domain != '' ? (
                      <div className='domain-notice'>
                        <label>
                          Será permitido apenas e-mails relacionados ao domínio <b>{domain}</b>
                        </label>
                      </div>
                    ) : null}
                    
                    {isSuperAdmin() ? (
                      
                        <div className='form-item mb-4' style={{marginBottom: 0}}>
                          <p>ID do Vendedor: </p>
                          <input
                            type='text'
                            className='form-control form-control-lg form-control-solid'
                            name='id_seller_super_admin'
                            placeholder='Digite o ID do Vendedor'
                            value={idSellerSuperAdmin}
                            onChange={(e) => setIdSellerSuperAdmin(e.currentTarget.value)}
                          />
                        </div>
                      
                    ) : null}

                    <div className='form-item'>
                      <p>E-mail: </p>
                      <input
                        type='text'
                        className={`form-control form-control-lg form-control-solid ${validateEmail()}`}
                        name='email'
                        placeholder='E-mail'
                        defaultValue={email}
                        onChange={(e) => setEmail(e.currentTarget.value)}
                      />
                    </div>
                    <div className='form-item'>
                      <p>Nome: </p>
                      <input
                        type='text'
                        className={`form-control form-control-lg form-control-solid ${validateName()}`}
                        name='name'
                        placeholder='Nome'
                        defaultValue={name}
                        onChange={(e) => setName(e.currentTarget.value)}
                      />
                    </div>

                    {/*props.userData?.is_seller && !isSuperAdmin() ? (
                      <div className='form-item'>
                        <p>ID Vendedor: </p>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          name='id_seller'
                          placeholder='ID do Vendedor'
                          value={idSeller}
                          onChange={(e) => setIdSeller(e.currentTarget.value)}
                        />
                      </div>
                    ) : null*/}

                    {isSuperAdmin() ? (
                      <div className='form-item'>
                        <p>Acesso: </p>
                        <select
                          className='form-select form-select-lg form-select-solid'
                          defaultValue={isAdmin}
                          onChange={({target: {value}}) => {
                            setIsAdmin(value == '1' ? 1 : 0)
                          }}
                        >
                          <option value='0'>Usuário</option>
                          <option value='1'>Administrador</option>
                        </select>
                      </div>
                    ) : null}

                    <div className='form-item'>
                      <p>Status: </p>
                      <div className='form-control d-flex'>
                        <div className='status-item'>
                          <label>Ativo</label>
                          <input
                            className='form-check-input'
                            type='radio'
                            name='status'
                            value='Ativo'
                            checked={isActived == 1}
                            onChange={({target: {value}}) => {
                              setIsActived(value == 'Ativo' ? 1 : 0)
                            }}
                          />
                        </div>
                        <div className='status-item'>
                          <label>Inativo</label>
                          <input
                            className='form-check-input'
                            type='radio'
                            name='status'
                            value='Inativo'
                            checked={isActived == 0}
                            onChange={({target: {value}}) => {
                              setIsActived(value == 'Ativo' ? 1 : 0)
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className='form-item'>
                      <p>Mailling: </p>
                      <div className='form-control d-flex'>
                        <div className='mailling-item'>
                          <label>Sim</label>
                          <input
                            className='form-check-input'
                            type='radio'
                            name='mailling'
                            value='Sim'
                            checked={isMailling === 1}
                            onChange={({target: {value}}) => {
                              setIsMailling(value == 'Sim' ? 1 : 0)
                            }}
                          />
                        </div>
                        <div className='mailling-item'>
                          <label>Não</label>
                          <input
                            className='form-check-input'
                            type='radio'
                            name='mailling'
                            value='Não'
                            checked={isMailling === 0}
                            onChange={({target: {value}}) => {
                              setIsMailling(value == 'Sim' ? 1 : 0)
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className='form-item'>
                      {isSuperAdmin() ? (
                        <div className='form-item'>
                          <p>Visualizador: </p>
                          <div className='form-control d-flex'>
                            <div className='viewer-item'>
                              <label>Sim</label>
                              <input
                                className='form-check-input'
                                type='radio'
                                name='viewer'
                                value='Sim'
                                checked={isViewer === 1}
                                onChange={({target: {value}}) => {
                                  setIsViewer(value === 'Sim' ? 1 : 0)
                                }}
                              />
                            </div>
                            <div className='viewer-item'>
                              <label>Não</label>
                              <input
                                className='form-check-input'
                                type='radio'
                                name='viewer'
                                value='Não'
                                checked={isViewer === 0}
                                onChange={({target: {value}}) => {
                                  setIsViewer(value === 'Sim' ? 1 : 0)
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </StyledForm>
                </div>
              </div>
              {status != '' && (
                <div className='text-center'>
                  <div className='alert alert-danger w-100 text-center'>
                    <div className='alert-text font-weight-bold'>{status}</div>
                  </div>
                </div>
              )}
              <div className='text-center'>
                <button
                  type='submit'
                  id='kt_sign_in_submit'
                  className='btn btn-lg btn-primary w-50 mb-5 mt-5'
                  disabled={validationStatus() != ''}
                  onClick={() => {
                    onSubmit()
                  }}
                >
                  {!loading && (
                    <span className='indicator-label'>
                      {props.userData ? 'Atualizar dados' : 'Criar usuário'}
                    </span>
                  )}
                  {loading && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Aguarde por favor...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </StyledModal>
  )
}

export default UserModal